module.exports = __webpack_public_path__ + "img/matreshka.e6e57ec7.svg";